import React from 'react';

import * as sharedStyles from './Home.module.scss';
import StageDetail from './StageDetail';
import { Statistics, Stage } from './Home';
import { StageStatisticsStatus } from './stageStatistics';
import {
  AccordionContent,
  AccordionControls,
  AccordionGroup,
  AccordionHeader,
  Link,
} from 'components/core';
import { Inline } from 'components/layout';

type StageProps = {
  stage: Stage;
  title: string;
  secondaryLink: string;
  secondaryContent: React.ReactNode;
  studyCategoryCount: React.ReactNode;
  studyCategoryLink: string;
  reviewerName: string;
  isOpen: boolean;
  stats: Statistics;
  status: StageStatisticsStatus;
};

const StageSummary = ({
  title,
  stage,
  secondaryContent,
  secondaryLink,
  studyCategoryCount,
  studyCategoryLink,
  reviewerName,
  stats,
  status,
  isOpen,
}: StageProps) => {
  return (
    <AccordionGroup
      className={sharedStyles.AccordionGroup}
      initiallyOpen={isOpen}
    >
      <AccordionHeader
        className={sharedStyles.AccordionHeader}
        chevronPosition="right"
        level={3}
      >
        <span className={sharedStyles.AccordionHeaderTitle}>{title}</span>
        <AccordionControls>
          <Inline
            spacing={4}
            className={sharedStyles.ControlsLinkContainer}
            alignX="right"
          >
            <Link
              variant="primary"
              to={secondaryLink}
              className={sharedStyles.ControlsLink}
            >
              {secondaryContent}
            </Link>
            <Link
              variant="primary"
              to={studyCategoryLink}
              className={sharedStyles.ControlsLink}
            >
              {studyCategoryCount}
            </Link>
          </Inline>
        </AccordionControls>
      </AccordionHeader>
      <AccordionContent>
        <StageDetail
          reviewerName={reviewerName}
          stage={stage}
          stats={stats}
          status={status}
          studyCategoryLink={studyCategoryLink}
        />
      </AccordionContent>
    </AccordionGroup>
  );
};

export default StageSummary;
